import { StateDataContext } from 'containers/Common/StateDataContext';
import { CreativeOfCampaign } from 'core/creative/Creative';
import { useCallback, useState } from 'react';
import styles from './bindCreativeStep.module.scss';
import { Button } from 'react-bootstrap';
import i18n from 'i18n';
import { BindCreativeStateContent } from 'components/CampaignCreativeManagement/BindCreativeStateContent';
import { BindCreativeInL2ObjectSetupFlowPageModel } from 'containers/Creatives/CreativeSetupFlow/CreativeSetupFlowPageModel';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { defaultTo } from 'lodash';

export const BindCreativeStep: React.FC<{
  model: BindCreativeInL2ObjectSetupFlowPageModel;
  goLast: () => void;
  goNext: (cb?: () => void) => void;
}> = ({ model, goNext, goLast }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const allCreatives = defaultTo(
    model.bindCreativeStateContentModel.creatives,
    []
  );
  const selectedCreativeId = model.creative
    ? model.creative.basic.creativeId
    : undefined;
  const selectedCreative = model.creative
    ? allCreatives.find((creative) => creative.id === selectedCreativeId)
    : undefined;
  const [data, setData] = useState<{
    activate: undefined;
    selectedCreatives: string[];
    campaignNewCreativesMap: {
      id: number;
      name: string;
      creatives: CreativeOfCampaign[];
    }[];
  }>({
    activate: undefined,
    selectedCreatives: selectedCreative ? [selectedCreative.id.toString()] : [],
    campaignNewCreativesMap: selectedCreative
      ? [{ id: 0, name: '', creatives: [selectedCreative] }]
      : []
  });

  const completeAndCheck = useCallback(async () => {
    if (
      data.campaignNewCreativesMap.length === 0 ||
      data.campaignNewCreativesMap[0].creatives.length === 0
    ) {
      return;
    }
    setLoading(true);
    const creative = data.campaignNewCreativesMap[0].creatives[0];
    const formModel = await model.getFormContentModelOfType(
      creative.creativeType,
      model.order.advertiserId
    );
    const creativeValues = JSON.stringify(creative.creativeValue);
    const formData = formModel.getFormModelData({
      basic: {
        agencyId: model.order.agencyId,
        advertiserId: model.order.advertiserId,
        bannerUrl: creative.bannerUrl,
        creativeId: creative.id,
        creativeType: creative.creativeType,
        landingPageUrl: creative.landingPageUrl,
        name: creative.name,
        tenmaxCategory: creative.tenmaxCategory,
        creativeValues,
        duration: creative.creativeValue.duration,
        bannerExtra: creative.bannerExtra
      },
      limitations: {
        include: [],
        exclude: [],
        preferred: [],
        nonPreferred: [],
        other: []
      }
    });

    setLoading(false);

    goNext(() => {
      model.setCreative({
        basic: formData.basic
      });
    });
  }, [model, data, goNext]);

  return (
    <div className={styles.bindCreativeContainer}>
      {loading && <LoadingIndicator />}
      <div className={styles.bindCreativeMain}>
        <StateDataContext.Provider
          value={{
            data: data,
            setData: setData
          }}
        >
          <BindCreativeStateContent
            model={model.bindCreativeStateContentModel}
          />
        </StateDataContext.Provider>
      </div>
      <div className={styles.buttonArea}>
        <Button
          variant='primary'
          size='sm'
          disabled={data.selectedCreatives.length === 0}
          onClick={completeAndCheck}
        >
          {i18n.t('common.buttons.confirm')}
        </Button>
        <Button variant='secondary' size='sm' onClick={goLast}>
          {i18n.t('campaign.buttons.back')}
        </Button>
      </div>
    </div>
  );
};
